import {NgModel} from './ngModel';

export const Program = NgModel.extend({
    _name: 'Program',
    defaults: {
        label: null,
    },
});
